import { Select } from "antd";
import { FormikErrors, FormikProps, FormikTouched } from "formik";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  IRuleCondition,
  IWorkflowRule,
  IWorkflowsSelectOption,
} from "../../../../../../../@types/Worflows";
import { ArrowDown } from "../../../../../../../assets/icons/ArrowDown";
import { IOption } from "../../../../../../../components/SelectDropdown";
import { getWorkflowOptionLabel } from "../../../../../../../utils/workflowOptionLabels";
import { ErrorMessage, selectCss } from "../../../WorkflowsBuilder.styles";
import { SelectContainer, popupOptionsCss } from "../RuleComponent.styles";

interface IFibricheckStatusFieldsProps {
  formik: FormikProps<IWorkflowRule>;
  fibricheckStatuses?: IWorkflowsSelectOption[];
}

export function FibricheckStatusFields({
  formik,
  fibricheckStatuses,
}: IFibricheckStatusFieldsProps) {
  const { t } = useTranslation();

  const shouldShowConditionError = (field: keyof IRuleCondition): string => {
    const touchedArray = formik.touched.conditions as
      | FormikTouched<IRuleCondition>[]
      | undefined;
    const errorArray = formik.errors.conditions as
      | FormikErrors<IRuleCondition>[]
      | undefined;

    if (touchedArray && errorArray) {
      const touched = touchedArray[0];
      const error = errorArray[0];

      return touched?.[field] && error?.[field] ? (error[field] as string) : "";
    }

    return "";
  };

  const statusOptions: IOption[] = useMemo(
    () =>
      fibricheckStatuses?.map((status) => ({
        label: getWorkflowOptionLabel("fibricheckStatus", status, t),
        value: status.type,
        key: status.type,
      })) ?? [],
    [fibricheckStatuses, t]
  );

  return (
    <SelectContainer
      isError={shouldShowConditionError("fibricheckStatus") !== ""}
    >
      <p>{t("workflows_rule_status")}</p>
      <Select
        placeholder={t("workflows_rule_status")}
        value={formik.values.conditions[0].fibricheckStatus}
        suffixIcon={<ArrowDown />}
        options={statusOptions}
        popupClassName={popupOptionsCss()}
        notFoundContent={t("workflows_rule_noData")}
        className={`${selectCss()} nopan nodrag`}
        onChange={(value) => {
          formik.setFieldValue("conditions[0].fibricheckStatus", value);
        }}
      />
      <ErrorMessage>
        {shouldShowConditionError("fibricheckStatus")}
      </ErrorMessage>
    </SelectContainer>
  );
}
